import ReceiptPaymentModeSummary from "@/components/receipt-payment-summary/ReceiptPaymentModeSummary";
import type { PaymentSummaryResponse } from "@/components/receipt-payment-summary/types";
import {
  buildYearlyNiyaazSummaryQuery,
  shouldFetchYearlyNiyaazPaymentSummary,
  YEARLY_NIYAAZ_PAYMENT_SUMMARY_PATH,
  YEARLY_NIYAAZ_SUMMARY_QUERY_KEYS,
  yearlyNiyaazPaymentSummaryCardsFromResponse,
} from "./yearly-niyaaz-receipt-payment-summary";

const parseYearlyNiyaazPaymentSummaryResponse = (json: unknown): PaymentSummaryResponse | null =>
  json && typeof json === "object" ? (json as PaymentSummaryResponse) : null;

export default function YearlyNiyaazReceiptPaymentSummary() {
  return (
    <ReceiptPaymentModeSummary
      apiResource="yearlyNiyaazReceipts"
      summaryPath={YEARLY_NIYAAZ_PAYMENT_SUMMARY_PATH}
      queryKeys={YEARLY_NIYAAZ_SUMMARY_QUERY_KEYS}
      shouldFetch={shouldFetchYearlyNiyaazPaymentSummary}
      buildQuery={buildYearlyNiyaazSummaryQuery}
      parseResponse={parseYearlyNiyaazPaymentSummaryResponse}
      cardsFromResponse={yearlyNiyaazPaymentSummaryCardsFromResponse}
    />
  );
}
